// src/components/SidebarToggle.js
import React from 'react';

const SidebarToggle = ({ isOpen, toggle }) => {
  return (
    <button 
      className="sidebar-toggle-btn" 
      onClick={toggle}
      aria-label={isOpen ? 'إغلاق القائمة' : 'فتح القائمة'}
    >
      {isOpen ? '×' : '☰'}
    </button>
  );
};

export default SidebarToggle;